import React from 'react';
import { Modal } from 'antd';
import PaidForm from './PaidForm';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function AddAgentWagePaid() {
    const general = useGeneralStore()
    const { NotifSuccess, ToggleAddAgentWagePaidModal } = general
    const visible = general.view.agentWagePaidModal;

    return (
        <Modal
            width={900}
            title="واریز به بازاریاب"
            className="custom-table"
            visible={visible}
            footer={false}
            onCancel={() => ToggleAddAgentWagePaidModal()}>
            <PaidForm
                onSubmit={() => {
                    ToggleAddAgentWagePaidModal();
                    NotifSuccess('واریز با موفقیت ثبت شد.');
                }}
            />
        </Modal>
    )
}
